import React from "react";

// Import images
import m1 from "../../../../../Assets/Images/defaultMedia1.jpeg";
import m2 from "../../../../../Assets/Images/defaultMedia2.jpeg";
import m3 from "../../../../../Assets/Images/defaultMedia3.jpeg";
export default function Media() {
  return (
    <section>
      <div>
        <label className="text-sm text-[#7C7C7C]">Today</label>
        <div className="flex flex-wrap gap-4 mt-2">
        {[m1, m2, m3].map((url, index) => (
            <div
              key={index}
              className="min-w-[114px] min-h-[114px] max-w-[114px] max-h-[114px] rounded-xl overflow-hidden"
            >
              <img
                src={url}
                alt={`media-${index}`}
                className="h-[114px]  w-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
      <div className="my-3">
        <label className="text-sm font-semibold">Yesterday</label>
        <div className="flex flex-wrap gap-4 mt-2">
        {[m1, m2, m3].map((url, index) => (
            <div
              key={index}
              className="min-w-[114px] min-h-[114px] max-w-[114px] max-h-[114px] rounded-xl overflow-hidden"
            >
              <img
                src={url}
                alt={`media-${index}`}
                className="h-[114px] w-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
